export class SetProjectObjectState {
  static readonly type = '[Project] Set Project Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[Project] Reset State';
  constructor() {}
}

export class UpdateProject {
  static readonly type = '[Project] Update Project';
  constructor(public project: any) {}
}

export class PrepareRequest {
  static readonly type = '[Project] Prepare Request';
  constructor(public tranOptions: any) {}
}
